import { createContext } from 'react';
import utils from 'utils';

export const DEFAULT_WRAPPER_CLASS = 'dash-page-wrapper';

type LayoutContextValues = {
  setWrapperClass: (newClass: string) => void;
  wrapperClass: string;
  defaultWrapperClass: string;
};

export default createContext<LayoutContextValues>({
  setWrapperClass: utils.noop,
  wrapperClass: DEFAULT_WRAPPER_CLASS,
  defaultWrapperClass: DEFAULT_WRAPPER_CLASS,
});
